import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import styled from 'styled-components';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import VitalStatistics from './pages/VitalStatistics';
import Skills from './pages/Skills';
import InTheMedia from './pages/InTheMedia';
import GlobalStyles from './styles/GlobalStyles';
import theme from './styles/Theme';

// overflow-x hidden goes on wrapper div, NOT body — body overflow-x breaks position:sticky on header
const AppWrapper = styled.div`
  overflow-x: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
`;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
        <Router>
          <AppWrapper>
            <Header />
            <Main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/vital-statistics" element={<VitalStatistics />} />
                <Route path="/skills" element={<Skills />} />
                <Route path="/in-the-media" element={<InTheMedia />} />
              </Routes>
            </Main>
            <Footer />
          </AppWrapper>
        </Router>
      </>
    </ThemeProvider>
  );
}

export default App;
